module.exports = __webpack_public_path__ + "img/image_2.f4180125.svg";